import React from 'react'
import { EventComponent } from 'stream-chat-react'
import type { EventComponentProps } from 'stream-chat-react'
import { t } from 'ttag'

// The backend attaches machine-readable yumType/yumUserName fields to system messages so each
// viewer sees them in their own language; message.text carries the English fallback used for
// unknown types (e.g. messages sent by a newer backend than this client). Also used by the
// chat list to translate the last-message preview.
export const translateSystemMessage = (message: { yumType?: string; yumUserName?: string } | null | undefined) => {
  const { yumType, yumUserName } = message || {}
  const name = yumUserName || ''
  switch (yumType) {
    case 'groupMemberJoined':
      return t`${name} joined the group`
    case 'groupMemberLeft':
      return t`${name} left the group`
    case 'challengeDeleted':
      return t`Challenge has been deleted`
    default:
      return undefined
  }
}

// Delegates to stream-chat-react's default system-message renderer with the translated text.
export const YumSystemMessage = (props: EventComponentProps) => {
  const translated = translateSystemMessage(props.message)
  if (!translated) return <EventComponent {...props} />
  return <EventComponent {...props} message={{ ...props.message, text: translated }} />
}
